/* Minimal AJAX form handler
   Usage: add data-ajax="true" to a <form>. Optional:
   - data-message-target: CSS selector for a container where messages should be inserted. Defaults to a div.form__message appended after the form.
   - data-success-message / data-error-message: fallback text if server returns no message.
   - data-response-format: "json" | "text" | "auto" (default auto).
*/
(function () {
  function ensureMessageContainer(form) {
    const targetSelector = form.getAttribute('data-message-target');
    if (targetSelector) {
      const el = document.querySelector(targetSelector);
      if (el) return el;
    }
    let el = form.querySelector('.form__message');
    if (!el) {
      el = document.createElement('div');
      el.className = 'form__message mt-2';
      form.appendChild(el);
    }
    return el;
  }

  function setMessage(container, type, message) {
    // type: 'success' | 'error' | 'info'
    container.innerHTML = '';
    container.classList.remove('form__message--error', 'form__message--success');
    if (type === 'error') container.classList.add('form__message--error');
    if (type === 'success') container.classList.add('form__message--success');
    const p = document.createElement('p');
    p.textContent = message;
    container.appendChild(p);
    container.style.display = message ? '' : 'none';
  }

  async function submitFormAjax(e) {
    const form = e.target;
    if (!form.matches('form[data-ajax="true"]')) return;
    e.preventDefault();

    const url = form.getAttribute('action') || window.location.href;
    const method = (form.getAttribute('method') || 'POST').toUpperCase();

    const formData = new FormData(form);
    const headers = new Headers();
    // Prefer JSON if explicitly requested and enctype is default
    const responseFormat = (form.getAttribute('data-response-format') || 'auto').toLowerCase();

    let body;
    if (form.enctype === 'multipart/form-data') {
      body = formData; // fetch handles boundary
    } else if (responseFormat === 'json' && method !== 'GET') {
      // Send JSON
      const plain = Object.fromEntries(formData.entries());
      body = JSON.stringify(plain);
      headers.set('Content-Type', 'application/json');
    } else {
      // Default: URL-encoded
      body = new URLSearchParams(formData);
      headers.set('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    }

    // Prevent Shopify redirect on certain endpoints by requesting JSON
    headers.set('Accept', 'application/json, text/html, */*;q=0.8');

    // must exist before the request so the catch block can report failures
    const msgContainer = ensureMessageContainer(form);

    try {
      const res = await fetch(url, {
        method,
        headers,
        body: method === 'GET' ? undefined : body,
        credentials: 'same-origin',
        redirect: 'manual'
      });

      // Try to parse response in order: JSON -> text
      let messageText = form.getAttribute('data-success-message') || 'Erfolgreich gesendet.';

      setMessage(msgContainer, 'success', messageText);
    } catch (err) {
      setMessage(
          msgContainer,
          'error',
          form.getAttribute('data-error-message') || 'Es ist ein Netzwerkfehler aufgetreten.'
      );
      // Optional: console
      console.error('[ajax-form] submit failed', err);
    }
  }

  function init(root = document) {
    root.addEventListener('submit', submitFormAjax, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
